import { render, staticRenderFns } from "./empty-cartridges-inventory.vue?vue&type=template&id=1fd8eeee&"
import script from "./empty-cartridges-inventory.vue?vue&type=script&lang=js&"
export * from "./empty-cartridges-inventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fd8eeee')) {
      api.createRecord('1fd8eeee', component.options)
    } else {
      api.reload('1fd8eeee', component.options)
    }
    module.hot.accept("./empty-cartridges-inventory.vue?vue&type=template&id=1fd8eeee&", function () {
      api.rerender('1fd8eeee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/device-manage/empty-cartridges-inventory/empty-cartridges-inventory.vue"
export default component.exports